import React from "react";

function Error500() {
  return (
    <div className="uk-height-1-1 uk-flex uk-flex-center uk-flex-middle uk-flex-column uk-text-center">

      <h1 className="uk-margin-small-bottom">Something went wrong</h1>

      <p className="uk-margin-small-top" style={{ maxWidth: '450px' }}>
        We're sorry, an unexpected error occurred. Please try again.
      </p>

    </div>
  )
}

export default Error500
